import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"
import React from "react"
import styles from "../incremental.module.scss"

const CustomTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderCollapse: "collapse !important",
  "& .MuiTableCell-root": {
    padding: "12px 24px 12px 0px",
    backgroundColor: theme.palette.background.default,
    borderBottom: "none",
    boxSizing: "border-box",
    "&:nth-of-type(1)": {
      position: "sticky",
      background: theme.palette.background.default,
      left: 0
    },
    "&:nth-of-type(2)": {
      background: "#1c1f21",
      position: "sticky",
      left: 50
    },
    "&:last-child": {
      paddingRight: 0
    }
  },
  "& .MuiTableRow-root": {
    borderBottom: `2px solid #272a2c`,
    "&:last-child": {
      borderBottom: "none"
    },
    "&:nth-last-of-type(2)": {
      borderBottom: "none"
    }
  },
  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "sticky",
    borderBottom: `2px solid #272a2c`,

    "&:nth-of-type(1)": {
      position: "sticky",
      background: theme.palette.background.default,
      left: 0,
      zIndex: 10
    },
    "&:nth-of-type(2)": {
      background: theme.palette.background.default,
      position: "sticky",
      left: 50,
      zIndex: 10
    },
    "&:last-child": {
      paddingRight: 0
    }
  }
}))

const TableFooter = styled(TableRow)(() => ({
  backgroundColor: "#282a2c",
  borderRadius: 6,
  zIndex: 20,
  position: "sticky",
  bottom: 0,
  marginBottom: 10,
  "& .MuiTableCell-root": {
    backgroundColor: "#282a2c",
    "&:first-of-type": {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6
    },
    "&:last-child": {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6
    }
  }
}))

const PerformanceIncrementalTable = ({ columns = [], rows = [] }) => {
  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: 700 }}>
        <CustomTable stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}>
                  <Typography variant="body2Regular" style={{ opacity: 0.6 }}>
                    {column.label}
                    {column.icon && <img className={styles.columnIcon} src={column.icon} alt="" />}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              return (
                <TableRow key={row.id}>
                  <TableCell>
                    <div className={row.rank <= 16 ? styles.rank : styles.rankDown}>{row.rank}</div>
                  </TableCell>
                  <TableCell>
                    <div className={`${styles.tableAvatar}`}>
                      <div
                        className={`${styles.tableAvatar__img} ${
                          row.rank === 1 && styles.borderImg
                        }`}>
                        <img src={row.image} />
                      </div>
                      <div className="d-flex flex-column">
                        <Typography variant="body2Regular">{row.name}</Typography>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.nonWCM}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">
                      {row.performanceGapImprove + "%"}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.incrementalMembership}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.annualized}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.performanceGap + "%"}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.invites}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.percentOfGoal}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.newTeamInvite}</Typography>
                  </TableCell>
                </TableRow>
              )
            })}
            <TableFooter>
              <TableCell />
              <TableCell />
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.nonWCM, 0)}
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.incrementalMembership, 0)}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.annualized, 0)}
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.invites, 0)}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {(rows.reduce((prev, el) => prev + el.percentOfGoal, 0) / rows.length).toFixed(
                    1
                  ) + "%"}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {(rows.reduce((prev, el) => prev + el.inviteRate, 0) / rows.length).toFixed(1) +
                    "%"}
                </Typography>
              </TableCell>
              <TableCell />
            </TableFooter>
          </TableBody>
        </CustomTable>
      </TableContainer>
    </Paper>
  )
}

export default PerformanceIncrementalTable
